<template>
  <section>
    <div v-if="fetching">
      <dh-loading-indicator />
    </div>
    <div class="null" v-if="!fetching">
      <null-state-image />
      <div class="content" :class="{'reverse': reverse}">
        <h3 tabindex="0">{{ header }}</h3>
        <p aria-hidden="true">{{ bodyText }}</p>
      </div>
      <slot></slot>
    </div>
  </section>
</template>

<script>
import NullStateSection from '~/components/null-state-section'
import NullStateImage from '../null-state-image'

export default {
  name: 'NullStateSection',
  components: { NullStateImage },
  mixins: [NullStateSection],
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  }
}
</script>


<style lang="scss" scoped>

  section {
    flex-grow: 1;
  }

  .null {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: $bp-small;
    margin: auto;
    padding: $space-060 0;

    @include tablet {
      padding: $d-large 0;
    }

    .image {
      @include ratio(1,1);
      width: 160px;
      background-image: none;
      margin-bottom: $space-060;
    }

    .content {

      h3 {
        @include title-lrg;
        color: $color-black;
        margin-bottom: $space-050;
        text-align: center;
      }

      p {
        @include body-med;
        margin-bottom: $d-med;
        text-align: center;
      }

      &.reverse {
        display: flex;
        flex-direction: column-reverse;

        h3 {
          margin: 0 $space-060 $d-med;
        }

        p {
          @include horizontal-lines();
          @include label-xx-sml;
          }
        }
      }
  }
</style>
